const input = {
    styleOverrides: {
        root: {
            /*fontSize: size.xs,
            color: text.secondary,*/
            /* '&:hover:not(.Mui-disabled):before': {
                borderBottom: `${borderWidth[1]} solid ${inputBorderColor}`,
            },

            '&:before': {
                borderColor: inputBorderColor,
            },

            '&:after': {
                borderColor: info.main,
            },*/
        },
    },
};

export default input;
